export interface IInsurance {
   id: string;
   name: string;
   insuranceKey: string;
   description: string;
   apiUrl: string;
   apiKey: string;
   createdAt: string;
}

export enum EApprovalPriority {
   LOW = 'LOW',
   MEDIUM = 'MEDIUM',
   HIGH = 'HIGH',
}

export enum EApprovalStatus {
   PENDING = 'PENDING',
   APPROVED = 'APPROVED',
   REJECTED = 'REJECTED',
}

export interface IApprovalRequest {
   id: string;
   insurance: IInsurance;
   patient: {
      firstName: string;
      lastName: string;
      nationalId: string;
      insuranceCode: string;
   };
   requestedItemName: string;
   requestedItemCode: string;
   requestedItemType: string;
   rejectionReason?: string;
   receptionistName?: string;
   dosagePeriod?: string;
   dosageQuantity?: string;
   dosageFrequency?: string;
   receptionistEmail?: string;
   callbackUrl?: string;
   caseId?: string;
   dosageForm?: string;
   message: string;
   status: 'PENDING' | 'APPROVED' | 'REJECTED';
   priority?: EApprovalPriority;
   medicalFacility?: string;
   createdAt: string;
}

export enum EMedicalItemType {
   DRUG = 'DRUG',
   CONSUMABLE = 'CONSUMABLE',
   MEDICAL_ACT = 'MEDICAL_ACT',
}

export interface ITranslation {
   en?: string;
   fr?: string;
   kin?: string;
}

export enum EMedicalItemStatus {
   ACTIVE = 'ACTIVE',
   OBSOLETE = 'OBSOLETE',
}
export interface IMedicalItem {
   id: string;
   name: string;
   description?: string;
   code: string; //auto-generated
   type: EMedicalItemType;
   translation?: ITranslation;
   status: EMedicalItemStatus;
}

export interface ITariff {
   id: string;
   medicalItem: IMedicalItem;
   unitPrice: number;
   code: string; //auto-generated
}

export interface IPatient {
   id: string;
   firstName: string;
   lastName: string;
   nationalId: string;
   insuranceCode: string;
   coverage: number;
}

export enum EBillPaymentStatus {
   PENDING = 'PENDING',
   PAID = 'PAID',
}

export interface IBill {
   id: string;
   patient: IPatient;
   insurance: IInsurance;
   items: {
      id: string;
      covered: boolean;
      medicalItem: IMedicalItem & {
         tariffs: ITariff[];
      };
      quantity: number;
   }[];
   pricing: {
      coveredByInsurance: number;
      coveredByPatient: number;
      total: number;
   };
   medicalFacility: string;
   caseID: string;
   createdAt: string;
   billCode: string;
   paymentStatus: EBillPaymentStatus;
}

export enum EMembershipType {
   DEPENDANT = 'DEPENDANT',
   AFFILIATE = 'AFFILIATE',
}
export enum EValidity {
   ACTIVE = 'ACTIVE',
   EXPIRED = 'EXPIRED',
}

export interface IInsuranceMember {
   id: string;
   firstName: string;
   lastName: string;
   nationalId: string;
   memberType: EMembershipType;
   insuranceCode: string;
   coverage: number;
   activatedAt: string;
   expirationAt: string;
   affiliate?: IInsuranceMember;
   dependants: IInsuranceMember[];
   validity: EValidity;
   package: {
      drugs: IMedicalItem[];
      consumables: IMedicalItem[];
      medicalActs: IMedicalItem[];
   };
}

/* RSSB Mocks */
export interface IRMPractitioner {
   id: string;
   documentNumber: string;
   documentType: string;
   practitionerLicenseNumber: string;
   practitionerTypeId: string;
   healthFacility: {
      id: string;
      facilityName: string;
      address: {
         districtId: string;
         districtName: string;
         sectorId: string;
      };
      ihbsIdentifier: string;
      facilityType: string;
      facilityCategory: string;
   };
   phoneNumber: string;
}
